import { render, staticRenderFns } from "./PartnerMonitor.vue?vue&type=template&id=3977c54a"
import script from "./PartnerMonitor.vue?vue&type=script&lang=js"
export * from "./PartnerMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports